import Slider from 'react-slick'

import { CarouselNext } from 'component/Common/CarouselNext'
import { CarouselPrev } from 'component/Common/CarouselPrev'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import styles from './styles.module.scss'

export const WhatStudentsDeveloped = props => {
  const { data } = props
  var settings = {
    dots: true,
    arrows: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '200px',
    nextArrow: <CarouselNext iconClassName={styles.arrow} />,
    prevArrow: <CarouselPrev iconClassName={styles.arrow} />,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          centerPadding: '100px',
        },
      },
      {
        breakpoint: 767,
        settings: {
          centerPadding: '0px',
          centerMode: false,
        },
      },
    ],
  }
  return (
    <section className={styles.whatStudentsDeveloped}>
      <div className="container">
        <header className={styles.whatStudentsDevelopedHeader}>
          {data?.title && <h2 className={styles.title}>{data?.title}</h2>}
          {data?.desc && <p className={styles.desc}>{data?.desc}</p>}
          {data?.symposiums && (
            <div className={styles.whatStudentsDevelopedHeaderSymposiums}>
              {data?.symposiums?.desc && (
                <p className={styles.desc}>{data?.symposiums?.desc}</p>
              )}
              {data?.symposiums?.locations && (
                <div
                  className={styles.whatStudentsDevelopedHeaderSymposiumsImages}
                >
                  {data?.symposiums?.locations?.map((loc, idx) => (
                    <img key={`symposium-${idx}`} src={loc.src} alt={loc.alt} />
                  ))}
                </div>
              )}
            </div>
          )}
        </header>
        <div className="row mb-50">
          <div className="col-12">
            <Slider
              {...settings}
              className={styles.whatStudentsDevelopedCarousel}
            >
              {data?.projects?.map((item, idx) => (
                <img
                  src={item}
                  alt={`What Students Developed ${idx + 1}`}
                  key={`what-studens-developed-img-${idx}`}
                />
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  )
}
